import { View } from 'foundations-components/components/View';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Public cards intentionally diverge from the shared MerchCardLayoutUI.
 *
 * The shared layout places every section (CTAs, BelowCTA, Features, Footer)
 * into its own named grid area, so each becomes a shared-height row band across
 * all columns. When one card has a section another lacks, the shorter card gets
 * an empty band of the taller card's height — a visible gap.
 *
 * Here we keep the grid only for the top sections (Title → Term) so price and the
 * TOP of the CTA buttons still line up across cards (everything above the button
 * is row-aligned, so the button-top line is at the same Y in every column).
 * Everything from the buttons down is collapsed into a single grid area rendered
 * as a per-card flex column, so it flows naturally and shifts up together with no
 * inter-section gaps. The grid item still stretches to the band height, keeping
 * the column divider border continuous.
 */
export const PublicMerchCardLayoutUI = ({
  'data-selenium-id': dataSeleniumId,
  columnStart,
  Title,
  Subheading,
  Pricing,
  BelowPrice,
  Term,
  CTAs,
  BelowCTA,
  Features,
  Footer
}) => {
  const layoutProps = {
    gridColumnStart: columnStart,
    gridColumn: `${columnStart} / span 1`
  };
  const styleProps = {
    paddingInline: '600',
    borderColor: 'border-core-subtle',
    borderWidth: '100',
    // Only the left border is drawn per item; it forms the divider line between columns
    borderInlineStartStyle: columnStart > 1 ? 'solid' : undefined
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Title",
      paddingBlockStart: "800",
      position: "relative",
      "data-selenium-id": dataSeleniumId
    }, layoutProps, styleProps, {
      children: Title
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Subheading",
      paddingBlockStart: "200"
    }, layoutProps, styleProps, {
      children: Subheading
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Pricing",
      paddingBlockStart: "400"
    }, layoutProps, styleProps, {
      children: Pricing
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Seats",
      paddingBlockStart: BelowPrice ? '400' : '0'
    }, layoutProps, styleProps, {
      children: BelowPrice
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Term",
      paddingBlockStart: Term ? '400' : '0'
    }, layoutProps, styleProps, {
      children: Term
    })), /*#__PURE__*/_jsxs(PPUIGridItem, Object.assign({
      gridArea: "CTAs",
      paddingBlockStart: "600",
      paddingBlockEnd: "600"
    }, layoutProps, styleProps, {
      children: [CTAs, BelowCTA ? /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "600",
        children: BelowCTA
      }) : null, /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "600",
        children: Features
      }), Footer ? /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "400",
        children: Footer
      }) : null]
    }))]
  });
};